import { animated } from '#app/components/Primitives/Animated.js';
import { springAnimation } from '#app/utilities/animation.js';
import { ChevronUpIcon } from '@contra/icons/icons';
import { forwardRef, type HTMLAttributes, type Ref } from 'react';
import { css, styled } from 'styled-components';

const Button = styled.button`
  ${({ theme }) => css`
    padding: 4px;
    border-radius: 4px;
    line-height: 1;

    &:hover,
    &:focus {
      background-color: ${theme.colorsV2.gray20};
    }

    & > svg {
      display: inline-block;
    }
  `}
`;

type TextFieldButtonProps = HTMLAttributes<HTMLButtonElement> & {
  readonly isOpen: boolean;
};

export const TextFieldButton = forwardRef(
  (
    { isOpen, onClick, ...props }: TextFieldButtonProps,
    ref: Ref<HTMLButtonElement>,
  ) => {
    return (
      <Button
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onClick?.(event);
        }}
        ref={ref}
        type="button"
        {...props}
      >
        <animated.div
          animate={{
            rotate: isOpen ? 0 : 180,
          }}
          initial={false}
          transition={springAnimation.fast}
        >
          <ChevronUpIcon
            focusable={false}
            size={24}
          />
        </animated.div>
      </Button>
    );
  },
);
